import React, { useEffect, useCallback } from 'react';
import {ReactComponent as Profile} from './my-profile.svg';
import './App.css';
import {ReactComponent as PersonalIcon} from './person-website-icon.svg';
import {ReactComponent as AtiniIcon} from './atini-logo.svg';
import {ReactComponent as LinkedInIcon} from './linkedin-icon.svg';
import {ReactComponent as UpworkIcon} from './upwork-icon.svg';
import {ReactComponent as GithubIcon} from './github-icon.svg';

interface LinkItem {
  title: string;
  url: string;
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
}

const links: LinkItem[] = [
  {
    title: 'Personal Website',
    url: 'https://christine-ting.com',
    Icon: PersonalIcon,
  },
  {
    title: 'Atini Studio',
    url: 'https://atinistudio.com',
    Icon: AtiniIcon,
  },
  {
    title: 'LinkedIn',
    url: 'https://www.linkedin.com/in/christine-ting',
    Icon: LinkedInIcon,
  },
  {
    title: 'Upwork',
    url: 'https://www.upwork.com/freelancers/~019d03f3f0b2d812c3',
    Icon: UpworkIcon,
  },
  {
    title: 'GitHub',
    url: 'https://github.com/christine-ting',
    Icon: GithubIcon,
  },
];

const LinkButton: React.FC<LinkItem> = React.memo(({ title, url, Icon }) => {
  const handleClick = useCallback(() => {
    window.open(url, '_blank');
  }, [url]);

  const handleKeyPress = useCallback((e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      window.open(url, '_blank');
    }
  }, [url]);

  return (
    <div 
      className="button-container" 
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyPress={handleKeyPress}
    >
      <div className={`icon-container ${title === 'Atini Studio' ? 'atini-logo' : ''}`}>
        <Icon height={24} width={24} />
      </div>
      <div className="button-text">{title}</div>
    </div>
  );
});

function App() {
  useEffect(() => {
    // Add smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';
  }, []);

  return (
    <div className="App">
      <div className="container">
        <Profile 
          className="profile-pic"
        />
        <h1 className="main-text">Christine Ting</h1>
        <p className="sub-text">Entrepreneur | Software Engineer | UC Berkeley Alumni</p>
        <div className="info-text">
          <a href="mailto:christine.ting@atinistudio.com">christine.ting@atinistudio.com</a>
          <span>|</span>
          <a href="tel:+9095032187">(909) 503-2187</a>
        </div>
        <div className="links">
          {links.map((link, index) => (
            <LinkButton key={index} {...link} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default React.memo(App);
